// src/data/moderation.ts
// Moderation word lists live in Firestore (gameConfig/moderation), so they can be edited
// without a deploy — previously they were arrays inside service files.
import { getDomain } from '../config/gameConfig';

interface ModerationList {
    id: string;
    description?: string;
    values: string[];
}

const listValues = (id: string): string[] =>
    getDomain<ModerationList>('moderation').find(entry => entry.id === id)?.values ?? [];

/** Substrings rejected when choosing a username. */
export const getForbiddenUsernameWords = (): string[] => listValues('forbiddenUsernameWords');
